import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TikTokPixel = () => {
    const location = useLocation();
    const TIKTOK_PIXEL_ID = "PIXEL_ID_HERE"; // Placeholder as requested

    useEffect(() => {
        if (!TIKTOK_PIXEL_ID || TIKTOK_PIXEL_ID === "PIXEL_ID_HERE" || window.ttq) return;

        (function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = (w[t] = w[t] || []);
            ttq.methods = [
                "page", "track", "identify", "instances", "debug", "on", "off"
            ];
            ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            for (var i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(ttq, ttq.methods[i]);
            }
            ttq.instance = function (t) {
                var e = ttq._i[t] || [];
                for (var n = 0; n < ttq.methods.length; n++) {
                    ttq.setAndDefer(e, ttq.methods[n]);
                }
                return e;
            };
            ttq.load = function (e) {
                var n = "https://analytics.tiktok.com/i18n/pixel/events.js";
                var o = d.createElement("script");
                o.type = "text/javascript";
                o.async = true;
                o.src = n + "?sdkid=" + e;
                var a = d.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(o, a);
            };

            ttq.load("PIXEL_ID_HERE");
            ttq.page();
        })(window, document, "ttq");
    }, [location]);

    return null;
};

export default TikTokPixel;
